import { render, staticRenderFns } from "./HuaxianOtherNews.vue?vue&type=template&id=1f1a7658&scoped=true&"
import script from "./HuaxianOtherNews.vue?vue&type=script&lang=js&"
export * from "./HuaxianOtherNews.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianOtherNews.vue?vue&type=style&index=0&id=1f1a7658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1a7658",
  null
  
)

export default component.exports